import { Routes } from '@angular/router';
import { AuthGuard } from 'remarketing-angular-library';

export const supportPageRoutes: Routes = [
  {
    path: 'support',
    loadComponent: () => import('./components/supportpage/supportpage.component').then(c => c.SupportpageComponent),
    canActivate: [AuthGuard],
  },
];
